var _rect, _text, _rect2, _text2, _text3, _text4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _circle, _circle2, _circle3, _circle4, _circle5, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle6, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1560 2340",
    width: 1560,
    height: 2340,
    role: "img",
    "aria-label": "Sledgehammers and Shit Umbrellas, front cover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sledgehammers and Shit Umbrellas, front cover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1560,
    height: 2340,
    fill: "#0b0b0b"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 190,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#eb6834",
    textAnchor: "start",
    letterSpacing: 6
  }, "A FIELD MANUAL FOR DIGITAL TRANSFORMATION")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 222,
    width: 140,
    height: 6,
    fill: "#eb6834"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 410,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 166,
    fontWeight: 800,
    fill: "#fcfcfb",
    textAnchor: "start",
    letterSpacing: -5
  }, "Sledgehammers")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 580,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 166,
    fontWeight: 800,
    fill: "#fcfcfb",
    textAnchor: "start",
    letterSpacing: -5
  }, "and Shit")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 750,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 166,
    fontWeight: 800,
    fill: "#fcfcfb",
    textAnchor: "start",
    letterSpacing: -5
  }, "Umbrellas")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 632,
    y1: 863,
    x2: 626,
    y2: 896,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 421,
    y1: 896,
    x2: 416,
    y2: 922,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 409,
    y1: 893,
    x2: 405,
    y2: 912,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 724,
    y1: 856,
    x2: 721,
    y2: 876,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 717,
    y1: 920,
    x2: 713,
    y2: 941,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 548,
    y1: 903,
    x2: 540,
    y2: 944,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 845,
    y1: 884,
    x2: 837,
    y2: 925,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 399,
    y1: 923,
    x2: 395,
    y2: 948,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 481,
    y1: 860,
    x2: 477,
    y2: 885,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1046,
    y1: 865,
    x2: 1040,
    y2: 897,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 897,
    y1: 882,
    x2: 891,
    y2: 913,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 413,
    y1: 855,
    x2: 409,
    y2: 878,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 932,
    y1: 886,
    x2: 927,
    y2: 912,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 852,
    y1: 889,
    x2: 847,
    y2: 914,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1027,
    y1: 909,
    x2: 1023,
    y2: 933,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 843,
    y1: 895,
    x2: 835,
    y2: 934,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 973,
    y1: 874,
    x2: 965,
    y2: 916,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 459,
    y1: 886,
    x2: 453,
    y2: 922,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 488,
    y1: 892,
    x2: 484,
    y2: 911,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 921,
    y1: 915,
    x2: 916,
    y2: 947,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 1095,
    y1: 877,
    x2: 1089,
    y2: 911,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 859,
    y1: 899,
    x2: 854,
    y2: 928,
    stroke: "#52514e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 96,
    fill: "none",
    stroke: "#262523",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 192,
    fill: "none",
    stroke: "#262523",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 288,
    fill: "none",
    stroke: "#262523",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 384,
    fill: "none",
    stroke: "#262523",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 480,
    fill: "none",
    stroke: "#262523",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 770.4,
    y: 1420,
    width: 19.2,
    height: 552,
    rx: 9.6,
    fill: "#fcfcfb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hammer-head"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 1930,
    width: 310,
    height: 132,
    rx: 10,
    fill: "#c3c2b7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 1930,
    width: 310,
    height: 22,
    rx: 10,
    fill: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 1922,
    width: 30,
    height: 148,
    rx: 6,
    fill: "#898781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 917,
    y: 1922,
    width: 30,
    height: 148,
    rx: 6,
    fill: "#898781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 1914,
    width: 56,
    height: 30,
    rx: 4,
    fill: "#eb6834"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770.1,1382.9 L660.7,974.9 A460.8,460.8 0 0 1 899.3,974.9 L789.9,1382.9 A38.4,38.4 0 0 0 770.1,1382.9 Z",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M789.9,1382.9 L876.9,1058.4 A374.4,374.4 0 0 1 1044.7,1155.3 L807.2,1392.8 A38.4,38.4 0 0 0 789.9,1382.9 Z",
    fill: "#52514e",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M807.2,1392.8 L1078.7,1121.3 A422.4,422.4 0 0 1 1188.0,1310.7 L817.1,1410.1 A38.4,38.4 0 0 0 807.2,1392.8 Z",
    fill: "#2a78d6",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M817.1,1410.1 L1067.5,1343.0 A297.6,297.6 0 0 1 1067.5,1497.0 L817.1,1429.9 A38.4,38.4 0 0 0 817.1,1410.1 Z",
    fill: "#3d3c39",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M817.1,1429.9 L965.5,1469.7 A192.0,192.0 0 0 1 915.8,1555.8 L807.2,1447.2 A38.4,38.4 0 0 0 817.1,1429.9 Z",
    fill: "#2c2b29",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M807.2,1447.2 L881.8,1521.8 A144.0,144.0 0 0 1 817.3,1559.1 L789.9,1457.1 A38.4,38.4 0 0 0 807.2,1447.2 Z",
    fill: "#1d1c1b",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M789.9,1457.1 L812.3,1540.5 A124.8,124.8 0 0 1 747.7,1540.5 L770.1,1457.1 A38.4,38.4 0 0 0 789.9,1457.1 Z",
    fill: "#1d1c1b",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M770.1,1457.1 L742.7,1559.1 A144.0,144.0 0 0 1 678.2,1521.8 L752.8,1447.2 A38.4,38.4 0 0 0 770.1,1457.1 Z",
    fill: "#1d1c1b",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M752.8,1447.2 L644.2,1555.8 A192.0,192.0 0 0 1 594.5,1469.7 L742.9,1429.9 A38.4,38.4 0 0 0 752.8,1447.2 Z",
    fill: "#2c2b29",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M742.9,1429.9 L474.0,1502.0 A316.8,316.8 0 0 1 474.0,1338.0 L742.9,1410.1 A38.4,38.4 0 0 0 742.9,1429.9 Z",
    fill: "#3d3c39",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M742.9,1410.1 L353.4,1305.7 A441.6,441.6 0 0 1 467.7,1107.7 L752.8,1392.8 A38.4,38.4 0 0 0 742.9,1410.1 Z",
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M752.8,1392.8 L508.5,1148.5 A384.0,384.0 0 0 1 680.6,1049.1 L770.1,1382.9 A38.4,38.4 0 0 0 752.8,1392.8 Z",
    fill: "#52514e",
    stroke: "#0b0b0b",
    strokeWidth: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 1420,
    r: 36,
    fill: "#fcfcfb"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 2230,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 76,
    fontWeight: 600,
    fill: "#fcfcfb",
    textAnchor: "start",
    letterSpacing: 0
  }, "Simon Stead")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1440,
    y: 2230,
    fontFamily: "Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 500,
    fill: "#898781",
    textAnchor: "end",
    letterSpacing: 0
  }, "For the people who make it happen")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverFront);
export default __webpack_public_path__ + "static/media/cover-front.81bec559c55824acef69fc6259194615.svg";
export { ForwardRef as ReactComponent };